import crud from '@/crud/form/form'
import resources from '../../resources'
import computed from './computed'
import methods from './methods'
import mounted from './mounted'
import validations from './validations'

export default {
  computed,
  methods,
  mounted,
  validations,
  mixins: [crud, resources]
}



// WEBPACK FOOTER //
// ./src/app/professional/company/companies/form/resources/index.js